import "react-loading-skeleton/dist/skeleton.css";

// Import global SCSS
import "../scss/style.scss";

import "./app/i18n";

// Import and initialize Quicklink
import { listen } from "quicklink";

// Import store to ensure it's initialized
import { store } from "./app/store";

// Import hydration system
import { hydrateComponents } from "./app/hydrate";

import { initHeader } from "./parts/header/header";
import { initScrollToTopButton } from "./parts/footer/scrollToTopButton";

import { initHomeContactForm } from "./partials/PageContent/homeContactForm";

import { initAccordion } from "./partials/PostContent/accordion";
import { initPostSlider } from "./partials/PostContent/slider";

import { initPageContactForm } from "./templates/contact/contactForm";

// Initialize Global Logic
const initGlobals = () => {
  initHeader();
  initScrollToTopButton();

  initHomeContactForm();

  initAccordion();
  initPostSlider();

  initPageContactForm();

  // Initialize Quicklink. It will automatically start listening for in-viewport links.
  listen();
  console.log(
    "[Main JS] Quicklink is listening for in-viewport links to prefetch."
  );

  // Hydrate all React components found on the page
  hydrateComponents();

  console.log("[Main JS] Main JS bundle initialized (Global).");
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
